module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-item",
    class: {
      last: _vm.isLast
    }
  }, [_c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.chartLabel)
    }
  }), _vm._v(":\n    "), _c('span', [_vm._v("\n              " + _vm._s(_vm.decimalize(_vm.value)) + "  / " + _vm._s(_vm.total) + _vm._s(_vm.unit) + "\n              ")])]), _vm._v(" "), _c('mu-linear-progress', {
    attrs: {
      "color": _vm.barMode === 'indeterminate' ? ("rgba(" + _vm.color + ", 0.24)") : _vm.color,
      "mode": _vm.barMode,
      "size": 16,
      "value": (_vm.value) ? ((_vm.value / _vm.total) > 100 ? 100 : (_vm.value / _vm.total) * 100) : 0
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7613c39e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FoodDiary/Graphs/ProgressItem/ProgressItem.vue
// module id = 3786
// module chunks = 1